<template>
  <div class="row">
    <div class="col-12 text-center">
      <el-switch v-model="month" active-text="月付" inactive-text="年付">
      </el-switch>
    </div>
    <br />
    <br />
    <div v-if="month" class="col-12">
      <main class="row">
        <div class="col-md-4">
          <div class="card-basic">
            <div class="card-header header-basic">
              <h1>免费</h1>
            </div>
            <div class="card-body">
              <h2>$0</h2>
              <div class="card-element-hidden-basic card-element-container">
                <div>&#42;活跃话题限制：3</div>
                <div>订阅标签限制: 3</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card-standard">
            <div class="card-header header-standard">
              <h1>白金会员</h1>
            </div>
            <div class="card-body">
              <h2>$5 / 月</h2>
              <div class="card-element-hidden-standard">
                <div>活跃话题限制：10</div>
                <div>订阅标签限制：10</div>
                <div>自定义个人主页</div>
                <div>查看其他用户已关闭话题</div>
                <div>关闭板块广告</div>
                <button
                  class="btn btn-standard"
                  @click="openDialog('silver_monthly')"
                >
                  订阅
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card-premium">
            <div class="card-header header-premium">
              <h1>黄金会员</h1>
            </div>
            <div class="card-body">
              <h2>$10 / 月</h2>
              <div class="card-element-hidden-premium">
                <ul class="card-element-container">
                  <div>活跃话题无限制</div>
                  <div>订阅标签无限制</div>
                  <div>自定义个人主页</div>
                  <div>查看其他用户已关闭话题</div>
                  <div>关闭板块广告</div>
                </ul>
                <button
                  class="btn btn-premium"
                  @click="openDialog('gold_monthly')"
                >
                  订阅
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
    <div v-else class="col-12">
      <main class="row">
        <div class="col-md-4">
          <div class="card-basic">
            <div class="card-header header-basic">
              <h1>免费</h1>
            </div>
            <div class="card-body">
              <h2>$0</h2>
              <div class="card-element-hidden-basic card-element-container">
                <div>&#42;活跃话题限制：3</div>
                <div>订阅标签限制: 3</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card-standard">
            <div class="card-header header-standard">
              <h1>白金会员</h1>
            </div>
            <div class="card-body">
              <h2>$50 / 年</h2>
              <div class="card-element-hidden-standard">
                <div>活跃话题限制：10</div>
                <div>订阅标签限制：10</div>
                <div>自定义个人主页</div>
                <div>查看其他用户已关闭话题</div>
                <div>关闭板块广告</div>
                <button
                  class="btn btn-standard"
                  @click="openDialog('silver_yearly')"
                >
                  订阅
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card-premium">
            <div class="card-header header-premium">
              <h1>黄金会员</h1>
            </div>
            <div class="card-body">
              <h2>$100 / 年</h2>
              <div class="card-element-hidden-premium">
                <ul class="card-element-container">
                  <div>活跃话题无限制</div>
                  <div>订阅标签无限制</div>
                  <div>自定义个人主页</div>
                  <div>查看其他用户已关闭话题</div>
                  <div>关闭板块广告</div>
                </ul>
                <button
                  class="btn btn-premium"
                  @click="openDialog('gold_yearly')"
                >
                  订阅
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
    <div class="col-12">
      <p>
        &#42;活跃话题：当话题失去时效性时，话题将会被关闭（被自己或者管理员关闭）。未被关闭的还具有时效性的话题即为活跃话题。
        用户可以有任意多的关闭的话题。关闭的话题不在搜索结果内。
      </p>
    </div>
    <div>
      <el-dialog :visible.sync="dialogVisible">
        <div>
          <h3>
            <span v-if="this.plan === 'silver_monthly'"
              >购买白金会员（$5/月）</span
            >
            <span v-if="this.plan === 'silver_yearly'"
              >购买白金会员（$50/年）</span
            >
            <span v-if="this.plan === 'gold_monthly'"
              >购买黄金会员（$10/月）</span
            >
            <span v-if="this.plan === 'gold_yearly'"
              >购买黄金会员（$100/年）</span
            >
          </h3>
        </div>
        <br />
        <FetchDefaultPayment
          :key="defaultPaymentKey"
          v-on:defaultPayment="getDefaultPayment"
        ></FetchDefaultPayment>
        <div v-if="defaultPayment.has_default">
          <br />
          <el-button @click="openCheckoutDialog"
            >使用已存支付方式 👉 下一步
          </el-button>
          <br />
          <br />
          <el-divider>或者在下方👇添加新卡</el-divider>
          <br />
        </div>
        <UpdatePayment :plan="plan"></UpdatePayment>
      </el-dialog>
      <el-dialog :visible.sync="checkoutDialog" v-loading="loadingSummary">
        <div>
          <h2>购买会员确认</h2>
          <div class="thick-padding">
            <hr />
            <div v-if="this.plan === 'silver_monthly'">
              <h3>
                白金会员（月付）
                <span class="float-right">${{ this.price }}</span>
              </h3>
              <ul class="checkout-description">
                <li>活跃话题限制：10</li>
                <li>订阅标签限制：10</li>
                <li>自定义个人主页</li>
                <li>查看其他用户已关闭话题</li>
                <li>关闭板块广告</li>
              </ul>
            </div>
            <div v-if="this.plan === 'silver_yearly'">
              <h3>
                白金会员（年付）
                <span class="float-right">${{ this.price }}</span>
              </h3>
              <ul class="checkout-description">
                <li>活跃话题限制：10</li>
                <li>订阅标签限制：10</li>
                <li>自定义个人主页</li>
                <li>查看其他用户已关闭话题</li>
                <li>关闭板块广告</li>
              </ul>
            </div>
            <div v-if="this.plan === 'gold_monthly'">
              <h3>
                黄金会员（月付）
                <span class="float-right">${{ this.price }}</span>
              </h3>
              <ul class="checkout-description">
                <li>活跃话题无限制</li>
                <li>订阅标签无限制</li>
                <li>自定义个人主页</li>
                <li>查看其他用户已关闭话题</li>
                <li>关闭板块广告</li>
              </ul>
            </div>
            <div v-if="this.plan === 'gold_yearly'">
              <h3>
                黄金会员（年付）
                <span class="float-right">${{ this.price }}</span>
              </h3>
              <ul class="checkout-description">
                <li>活跃话题无限制</li>
                <li>订阅标签无限制</li>
                <li>自定义个人主页</li>
                <li>查看其他用户已关闭话题</li>
                <li>关闭板块广告</li>
              </ul>
            </div>
            <hr />
            <div v-if="couponAmountOff !== 0">
              <h3>
                折扣码打折
                <span class="float-right"> -${{ this.couponAmountOff }} </span>
              </h3>
              <hr />
            </div>
            <div class="row">
              <div class="col-md-6">
                <el-input
                  style="width: 70%"
                  v-model="coupon"
                  placeholder="折扣码"
                >
                </el-input>
                <el-button
                  class="float-right"
                  @click="applyCoupon"
                  type="success"
                >
                  使用
                </el-button>
              </div>
              <div class="col-md-6 empty-top">
                <h3 class="float-right">
                  共计: &nbsp; ${{ this.price - this.couponAmountOff }}
                </h3>
              </div>
            </div>
            <br />
            <div>
              <el-button class="float-right" @click="subscribe" type="success">
                购买
              </el-button>
            </div>
          </div>
        </div>
        <br />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import UpdatePayment from "@/components/UpdatePayment";
import FetchDefaultPayment from "@/components/FetchDefaultPayment";

export default {
  data() {
    return {
      month: false,
      client_secret: "",
      defaultPayment: {
        has_default: false,
        card_brand: "visa",
        card_last_four: "0000"
      },
      dialogVisible: false,
      checkoutDialog: false,
      plan: "",
      coupon: "",
      couponObject: "",
      couponValid: false,
      couponAmountOff: 0,
      defaultPaymentKey: 1,
      paymentMethod: "",
      price: 0,
      totalPrice: 0,
      loadingSummary: false
    };
  },
  components: {
    UpdatePayment,
    FetchDefaultPayment
  },
  methods: {
    getDefaultPayment(payload) {
      this.defaultPayment = payload;
    },
    openDialog(plan) {
      this.dialogVisible = true;
      this.plan = plan;
    },
    applyCoupon() {
      if (!this.coupon) {
        this.couponAmountOff = 0;
        this.couponValid = false;
        return;
      }
      this.loadingSummary = true;
      this.$axios
        .post("/coupons/" + this.coupon, { plan: this.plan })
        .then(res => {
          // this.coupon = res.data;
          this.couponObject = res.data;
          this.couponAmountOff = this.couponObject.amount_off;
          if (!this.couponAmountOff) {
            this.couponAmountOff =
              (this.price * this.couponObject.percent_off) / 100;
          }
          this.totalPrice = this.price - this.couponAmountOff;
          this.$message({
            type: "success",
            showClose: true,
            message: "折扣码使用成功！"
          })
          this.loadingSummary = false;
          this.couponValid = true;
        })
        .catch(e => {
          this.couponValid = false;
          this.couponAmountOff = 0;
          this.$message({
            type: "error",
            showClose: true,
            message: e.response.data
          })
          this.loadingSummary = false;
        });
    },
    openCheckoutDialog() {
      this.checkoutDialog = true;
      this.dialogVisible = false;
      this.$axios
        .get("/prices/" + this.plan)
        .then(res => (this.price = res.data.unit_amount / 100))
        .catch(() => {
          let plans = {
            silver_monthly: 5,
            gold_monthly: 10,
            silver_yearly: 50,
            gold_yearly: 100
          };
          this.price = plans[this.plan];
        })
        .finally((this.totalPrice = this.price));
    },
    subscribe() {
      var data = {
        paymentMethod: this.paymentMethod
      };
      if (this.couponValid) {
        data["coupon"] = this.coupon;
      }
      this.$http
        .post("/user/subscription/" + this.plan, data)
        .then(res => {
          if (res.status === 201) {
            this.$message({
              type: "success",
              showClose: true,
              message: "成功订阅"
            })
            window.location.href =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname;
          }
        })
        .catch(err => {
          this.$message({
            showClose: true,
            type: "error",
            message: err.response.data
          });
        });
    },
    updateDefaultPayment: function(payment_method) {
      this.$http
        .put("/user/payment", { payment_method: payment_method })
        .then(res => {
          if (res.status === 201) {
            this.$message({
              showClose: true,
              type: "success",
              message: "成功更新支付方式"
            });
            this.defaultPaymentKey = Math.random();
          }
        })
        .catch(ex => {
          this.$message({
            showClose: true,
            type: "error",
            message: "更新支付方式失败，请稍后重试！"
          });
        });
    },
    async checkStatus() {
      const clientSecret = new URLSearchParams(window.location.search).get(
        // "payment_intent_client_secret"
        "setup_intent_client_secret"
      );

      if (!clientSecret) {
        return;
      }

      const plan = new URLSearchParams(window.location.search).get(
        // "payment_intent_client_secret"
        "plan"
      );

      if (!plan) {
        this.$message({
          showClose: true,
          type: "error",
          message: "银行卡信息更新成功，但是会员未购买成功！"
        });
        return;
      }

      const stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
      const { setupIntent } = await stripe.retrieveSetupIntent(clientSecret);

      switch (setupIntent.status) {
        case "succeeded":
          // this.$message.success("银行卡信息更新成功!");
          // set up default payment for customer.
          this.updateDefaultPayment(setupIntent.payment_method);
          this.paymentMethod = setupIntent.payment_method;
          this.plan = plan;
          // this.subscribe();
          this.openCheckoutDialog();
          break;
        case "processing":
          this.$message({
            type: "success",
            showClose: true,
            message: "银行卡信息处理中!"
          })
          break;
        case "requires_payment_method":
          this.$message({
            showClose: true,
            type: "error",
            message: "银行卡信息出错，请稍后重试！"
          });
          break;
        default:
          this.$message({
            showClose: true,
            type: "error",
            message: "银行卡信息出错，请稍后重试！"
          });
          break;
      }
    }
  },
  mounted: function() {
    this.checkStatus();
  }
};
</script>

<style scoped>
main {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.card-basic,
.card-premium,
.card-standard {
  margin: 0 2rem 1rem 0;
  padding: 0 0 0.5rem 0;
  width: 100%;
  background: var(--color-canvas-default);
  color: var(--color-fg-default);
  text-align: center;
  border-radius: 1rem;
  box-shadow: 0.5rem 0.5rem 1rem rgba(51, 51, 51, 0.2);
  overflow: hidden;
  transition: all 0.1ms ease-in-out;
}

.card-basic:hover,
.card-premium:hover,
.card-standard:hover {
  transform: scale(1.02);
}

.card-header {
  height: 5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 0.8rem;
  padding: 1rem 0;
  color: var(--color-fg-default);
  clip-path: polygon(0 0, 100% 0%, 100% 85%, 0% 100%);
}

.header-basic,
.btn-basic {
  background: linear-gradient(
    135deg,
    #3fb950,
    var(--color-checks-donut-success)
  );
}

.header-standard,
.btn-standard {
  background: linear-gradient(
    135deg,
    #6ea300,
    var(--color-checks-donut-neutral)
  );
}

.header-premium,
.btn-premium {
  background: linear-gradient(135deg,
  #8ea300,
  var(--color-checks-donut-pending)
  );
}

.card-body {
  padding: 0.5rem 0;
}

.card-body h2 {
  font-size: 2rem;
  font-weight: 700;
}

.card-element-container {
  color: var(--color-fg-default);
  list-style: none;
}

.btn {
  margin: 0.5rem 0;
  padding: 0.7rem 1rem;
  outline: none;
  border-radius: 1rem;
  font-size: 1rem;
  font-weight: 700;
  color: var(--color-fg-default);
  border: none;
  cursor: pointer;
  transition: all 0.1ms ease-in-out;
}

.btn:hover {
  transform: scale(0.95);
}

.btn:active {
  transform: scale(1);
}

.card-element-hidden {
  display: none;
}

.thick-padding {
  padding: 30px;
}

.checkout-description {
  color: var(--color-fg-muted);
}

.empty-top {
  margin-top: 20px;
}
</style>
